import { render, staticRenderFns } from "./ShippedToStore.vue?vue&type=template&id=177bdafd&scoped=true"
import script from "./ShippedToStore.vue?vue&type=script&lang=js"
export * from "./ShippedToStore.vue?vue&type=script&lang=js"
import style0 from "./ShippedToStore.vue?vue&type=style&index=0&id=177bdafd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177bdafd",
  null
  
)

export default component.exports